<template>
  <div class="wrap">
    <button class="current" @click="open = !open">
      {{$t('language')}}
    </button>
    <div class="options" v-if="open">
      <button class="option" v-for="locale in locales" @click="setLocale(locale.code)">
        {{locale.name}}
      </button>
    </div>
  </div>
</template>

<script>
import track from 'lib/track';

export default {
  props: {
    animal: String,
    initialX: Number,
    initialY: Number,
  },
  data() {
    const { messages } = this.$i18n;
    return {
      locales: Object.keys(messages).map(code => ({
        code,
        name: messages[code].language,
      })),
      open: false,
    };
  },
  methods: {
    setLocale(code) {
      this.$i18n.locale = code;
      this.open = false;

      track('Locale', 'Manual', 'Set', code);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  position: relative;
  width: 7em;
}

.current,
.option {
  background: white;
  border: 1px solid #ccc;
  cursor: pointer;
  padding: 0.325em 0.5em;
  width: 100%;
}

.options {
  bottom: 100%;
  left: 0;
  position: absolute;
  width: 100%;

  .option {
    border-bottom: 0;
    display: block;

    &:hover {
      background: #ddd;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Locale.vue?efd911ba